interface Props {
  fromName: string;
  fromEmail: string;
  createdAt: string;
}

export function TicketMeta({ fromName, fromEmail, createdAt }: Props) {
  return (
    <div
      className='grid grid-cols-2 gap-4 text-sm rounded-lg p-4 card-glow'
      style={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
      }}
    >
      <div>
        <p className='text-[10px] font-bold tracking-[0.12em] uppercase mb-1.5' style={{ color: 'var(--muted-foreground)' }}>
          From
        </p>
        <p className='font-semibold text-sm'>{fromName}</p>
        <p className='text-xs font-mono-data mt-0.5' style={{ color: 'var(--muted-foreground)' }}>{fromEmail}</p>
      </div>
      <div>
        <p className='text-[10px] font-bold tracking-[0.12em] uppercase mb-1.5' style={{ color: 'var(--muted-foreground)' }}>
          Created
        </p>
        <p className='font-mono-data text-sm'>{new Date(createdAt).toLocaleString()}</p>
      </div>
    </div>
  );
}
